"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBodyStyle = exports.useHeaderStyle = exports.RightColumn = exports.CustomDiv = exports.LeftColumn = exports.Item = exports.MiddleColumn = void 0;
var styled_components_1 = require("styled-components");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var StyledDivBase = (0, core_1.styled)('div')({
    width: function (props) { return props.width; }
});
var StyledDivLeft = (0, core_1.styled)(StyledDivBase)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexShrink: 0
});
var StyledDivRight = (0, core_1.styled)(StyledDivBase)({
    textAlign: 'right',
    flexShrink: 0
});
exports.MiddleColumn = (0, core_1.styled)('div')({
    flexBasis: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left'
});
var Item = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, height = _a.height, minHeight = _a.minHeight, cursor = _a.cursor;
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var clearButton = {
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        cursor: cursor !== null && cursor !== void 0 ? cursor : (disabled ? 'initial' : 'pointer'),
        background: 'transparent',
        outline: 'none',
        border: 'none',
        padding: '0',
        fontFamily: 'Montserrat-Light',
        width: '100%'
    };
    return (react_1.default.createElement("div", { style: {
            minHeight: minHeight,
            height: height,
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            color: disabled
                ? themeContext === null || themeContext === void 0 ? void 0 : themeContext.colors.lightgrey
                : themeContext === null || themeContext === void 0 ? void 0 : themeContext.colors.cremewhite
        } }, onClick != null ? (react_1.default.createElement("button", { type: 'button', style: clearButton, onClick: onClick }, children)) : (react_1.default.createElement("div", { style: clearButton }, children))));
};
exports.Item = Item;
var useSideWidth = function () {
    var materialThemeContext = (0, core_1.useTheme)();
    var upSm = (0, core_1.useMediaQuery)(materialThemeContext.breakpoints.up('sm'));
    var upLg = (0, core_1.useMediaQuery)(materialThemeContext.breakpoints.up('lg'));
    return (upLg ? 72 : upSm ? 56 : 32) + "px";
};
var LeftColumn = function (_a) {
    var children = _a.children;
    var width = useSideWidth();
    return react_1.default.createElement(StyledDivLeft, { width: width }, children);
};
exports.LeftColumn = LeftColumn;
var CustomDiv = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", null, children));
};
exports.CustomDiv = CustomDiv;
var RightColumn = function (_a) {
    var children = _a.children;
    var width = useSideWidth();
    return react_1.default.createElement(StyledDivRight, { width: width }, children);
};
exports.RightColumn = RightColumn;
var useHeaderStyle = function () {
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    return {
        backgroundColor: themeContext === null || themeContext === void 0 ? void 0 : themeContext.colors.darkgrey,
        color: themeContext === null || themeContext === void 0 ? void 0 : themeContext.colors.cremewhite
    };
};
exports.useHeaderStyle = useHeaderStyle;
var useBodyStyle = function () {
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    return {
        overflowY: 'auto',
        backgroundColor: themeContext === null || themeContext === void 0 ? void 0 : themeContext.colors.darkgrey,
        color: themeContext === null || themeContext === void 0 ? void 0 : themeContext.colors.cremewhite,
        padding: '32px',
        paddingLeft: themeContext === null || themeContext === void 0 ? void 0 : themeContext.variables.paddingNormal,
        paddingRight: themeContext === null || themeContext === void 0 ? void 0 : themeContext.variables.paddingNormal
    };
};
exports.useBodyStyle = useBodyStyle;
//# sourceMappingURL=ItemList.js.map